export enum AUTH_SESSION_STORAGE_KEYS {
  ORIGINAL_ROUTE = 'original-route'
}
